export const ua = {
  activate: 'Активувати'
};
